import * as R from 'ramda'
import { WappCondition, WappStage } from './types'

const conditionToStagesMap = {
  [WappCondition.RUN_WAPP]: [WappStage.LOADING, WappStage.RUNNING],
  [WappCondition.SHOW_LOADING]: [WappStage.LOADING],
  [WappCondition.RECEIVE_MESSAGE]: [WappStage.RUNNING],
}

export const stageIsSatisfyingCondition = (
  condition: WappCondition,
  stage: WappStage,
) => R.includes(stage, conditionToStagesMap[condition])

export const asyncDelay = (delay = 0) =>
  new Promise(resolve => {
    setTimeout(() => resolve(null), delay)
  })
